import { CustomerTransactionProductType } from '../types/CustomerTransactionProductType';

export const productTypesOrdered = [
    CustomerTransactionProductType.Invoice,
    CustomerTransactionProductType.Reminder,
    CustomerTransactionProductType.PreLegal,
    CustomerTransactionProductType.Legal,
    CustomerTransactionProductType.Surveillance
];